var exports = {
  "k": "x04b3a21e--43121a--container",
};

module.exports = exports;
